import HomePage from "../pages/HomePage";
import ProjectsPage from "../pages/ProjectsPage/index";
import AboutPage from "../pages/AboutPage/index";
import ProjectPage from "../pages/ProjectDetails";
import projectsData from "../projectsData";
import productsData from "../pages/ProductsPage/productsdata";
import ProductsPage from "../pages/ProductsPage";
import LinksPage from "../pages/LinksPage";
import ContactPage from "../pages/ContactPage";
import ErrorPage from "../pages/ErrorPage";

import StorefrontIcon from '@material-ui/icons/Storefront';
import {
  HomeRounded,
  InfoRounded,
  CodeRounded,
  Link,
} from "@material-ui/icons";

const routesData = [
  {
    pageName: "Home",
    pageURL: "/",
    showOnHeader: true,
    component: <HomePage />,
    icon: <HomeRounded />,
  },
  {
    pageName: "About",
    pageURL: "/about",
    showOnHeader: true,
    component: <AboutPage />,
    icon: <InfoRounded />,
  },
  {
    pageName: "Projects",
    pageURL: "/projects",
    showOnHeader: true,
    component: <ProjectsPage projects={projectsData} />,
    icon: <CodeRounded />,
  },
  {
    pageName: "Store",
    pageURL: "/store",
    showOnHeader: true,
    component: <ProductsPage products={productsData} />,
    icon: <StorefrontIcon />,
  },
  {
    pageName: "Links",
    pageURL: "/links",
    showOnHeader: true,
    component: <LinksPage />,
    icon: <Link />,
  },
  {
    pageName: "Projects",
    pageURL: "/projects/:id",
    showOnHeader: false,
    component: <ProjectPage projectData={projectsData} />,
  },
  {
    pageName: "Contact",
    pageURL: "/contact",
    showOnHeader: false,
    component: <ContactPage />,
  },
  {
    pageName: "Error",
    pageURL: "/error",
    showOnHeader: false,
    component: <ErrorPage />
  },
];

export default routesData;
